import { humanizeEnum } from '@helpers/labels';

/** Every drip sequence is eight steps long, for job seekers and employers alike. */
export const DRIP_STEPS = 8;

/**
 * The behavioural flags that are set, as readable labels.
 *
 * The table used to print the raw keys joined by commas ("companyProfileN..."), which was both the
 * widest cell in the row and unreadable once truncated. The cell now shows a count and these labels
 * go in its tooltip.
 */
export const activeFlagLabels = (flags: Record<string, boolean> | null | undefined): string[] =>
  Object.entries(flags ?? {})
    .filter(([, on]) => on)
    .map(([key]) => humanizeEnum(key));

export interface ProgressCell {
  /** The main line: where the sequence is. */
  primary: string;
  /** The second line: how much has gone out. */
  secondary: string;
  done: boolean;
}

/**
 * "Next step" and "Steps" were two columns describing one thing. A completed sequence has no next
 * step, so it says so instead of showing a bare tick.
 */
export const progressCell = (
  status: string,
  currentStep: number,
  sentSteps: number[] | null | undefined,
): ProgressCell => {
  const sent = sentSteps?.length ?? 0;
  const secondary = `${sent} of ${DRIP_STEPS} sent`;
  if (status === 'COMPLETED') return { primary: 'Finished', secondary, done: true };
  return { primary: `Next: step ${Math.min(currentStep + 1, DRIP_STEPS)}`, secondary, done: false };
};
